import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface ExitTraceModeArgs extends CanvasArgs {
  /** Client-side delegate that exits trace mode without deleting the trace. */
  action?: () => void
}

export class ExitTraceModeCommand extends CanvasBaseCommand<ExitTraceModeArgs> {
  readonly id = 'exit-trace-mode'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'close'
  override label = 'Exit trace mode'
  override tooltip = 'Exit trace mode'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: ExitTraceModeArgs): boolean {
    return !!args?.isTraceMode
  }

  protected doExecute(args?: ExitTraceModeArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
